import React from 'react';

interface IIbUrlProps {
  url: string;
}

const IbUrl: React.FC<IIbUrlProps> = ({ url }) => {
  if (!URL.canParse(url)) {
    return <>{url}</>;
  }

  return (
    <a href={url} rel="noreferrer" target="_blank">
      {url}
    </a>
  );
};

export default IbUrl;
